(() => {
  const SELECTOR_GALLERY = "[data-pubu-gallery]";
  const SELECTOR_ITEM = ".pubu-item";
  const SELECTOR_TRIGGER_IMG = ".pubu-lightbox-trigger img";
  const SELECTOR_VIEWMORE = "[data-pubu-viewmore]";

  let modalEl = null;
  let imgEl = null;
  let counterEl = null;
  let current = 0;
  let sources = [];
  let lastActiveEl = null;

  function buildModalOnce() {
    if (modalEl) return;

    modalEl = document.createElement("div");
    modalEl.className = "pubu-lightbox";
    modalEl.innerHTML = `
      <div class="pubu-lightbox__backdrop" data-pubu-close></div>
      <div class="pubu-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Image preview">
        <div class="pubu-lightbox__panel">
          <button class="pubu-lightbox__btn pubu-lightbox__close" type="button" aria-label="Close" data-pubu-close>✕</button>
          <button class="pubu-lightbox__btn pubu-lightbox__prev" type="button" aria-label="Previous">‹</button>
          <button class="pubu-lightbox__btn pubu-lightbox__next" type="button" aria-label="Next">›</button>

          <div class="pubu-lightbox__imgwrap">
            <img class="pubu-lightbox__img" alt="" />
          </div>

          <div class="pubu-lightbox__counter" aria-live="polite"></div>
        </div>
      </div>
    `;
    document.body.appendChild(modalEl);

    imgEl = modalEl.querySelector(".pubu-lightbox__img");
    counterEl = modalEl.querySelector(".pubu-lightbox__counter");

    modalEl.addEventListener("click", (e) => {
      const close = e.target.closest("[data-pubu-close]");
      if (close) closeModal();
    });

    modalEl.querySelector(".pubu-lightbox__prev").addEventListener("click", () => step(-1));
    modalEl.querySelector(".pubu-lightbox__next").addEventListener("click", () => step(1));

    document.addEventListener("keydown", (e) => {
      if (!modalEl.classList.contains("is-open")) return;
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowLeft") step(-1);
      if (e.key === "ArrowRight") step(1);
    });

    // swipe
    let startX = 0;
    let startY = 0;
    let active = false;

    modalEl.addEventListener("touchstart", (e) => {
      if (!modalEl.classList.contains("is-open")) return;
      const t = e.touches[0];
      startX = t.clientX;
      startY = t.clientY;
      active = true;
    }, { passive: true });

    modalEl.addEventListener("touchend", (e) => {
      if (!active) return;
      active = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      if (Math.abs(dx) > 50 && Math.abs(dy) < 40) {
        step(dx > 0 ? -1 : 1);
      }
    }, { passive: true });
  }

  // ONLY use img.src (user requirement)
  function getUrlFromImgSrc(img) {
    // Shopify outputs &amp; sometimes in HTML; normalize it
    return (img?.getAttribute("src") || img?.src || "").replace(/&amp;/g, "&");
  }

  function getVisibleImgs(galleryEl) {
    const imgs = Array.from(galleryEl.querySelectorAll(SELECTOR_TRIGGER_IMG));
    return imgs.filter((img) => {
      const item = img.closest(SELECTOR_ITEM);
      return !item || !item.classList.contains("is-hidden");
    });
  }

  function openModal(index) {
    if (!sources.length) return;
    buildModalOnce();

    lastActiveEl = document.activeElement;
    modalEl.classList.add("is-open");
    document.documentElement.style.overflow = "hidden";

    showIndex(index, 0);
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.classList.remove("is-open");
    document.documentElement.style.overflow = "";

    if (lastActiveEl && typeof lastActiveEl.focus === "function") {
      lastActiveEl.focus();
    }
  }

  function showIndex(index, direction) {
    current = (index + sources.length) % sources.length;

    const { url, alt } = sources[current];

    imgEl.classList.add("is-changing");
    imgEl.classList.toggle("is-from-left", direction < 0);

    requestAnimationFrame(() => {
      const pre = new Image();
      pre.onload = () => {
        imgEl.src = url;
        imgEl.alt = alt || "";
        counterEl.textContent = `${current + 1} / ${sources.length}`;

        requestAnimationFrame(() => {
          imgEl.classList.remove("is-changing", "is-from-left");
        });
      };
      pre.src = url;
    });
  }

  function step(delta) {
    if (!sources.length) return;
    showIndex(current + delta, delta);
  }

  function bindLightbox(galleryEl) {
    const triggers = Array.from(galleryEl.querySelectorAll(".pubu-lightbox-trigger"));
    if (!triggers.length) return;

    // Avoid double-binding
    if (galleryEl.dataset.pubuLbBound === "1") return;
    galleryEl.dataset.pubuLbBound = "1";

    triggers.forEach((btn) => {
      btn.addEventListener("click", () => {
        // Build sources from CURRENTLY visible images only
        const visibleImgs = getVisibleImgs(galleryEl);
        const clickedImg = btn.querySelector("img");
        if (!clickedImg) return;

        const idx = visibleImgs.indexOf(clickedImg);
        if (idx < 0) return;

        sources = visibleImgs.map((img) => ({
          url: getUrlFromImgSrc(img),
          alt: img.getAttribute("alt") || ""
        })).filter(x => !!x.url);

        if (!sources.length) return;
        openModal(idx);
      });
    });
  }

  function bindViewMore(galleryEl) {
    const btn = galleryEl.parentElement?.querySelector(SELECTOR_VIEWMORE);
    if (!btn) return;

    if (btn.dataset.pubuVmBound === "1") return;
    btn.dataset.pubuVmBound = "1";

    const step = parseInt(btn.getAttribute("data-step"), 10) || 12;

    function updateButtonVisibility() {
      const hidden = galleryEl.querySelectorAll(`${SELECTOR_ITEM}.is-hidden`).length;
      if (hidden <= 0) btn.classList.add("is-hidden");
      else btn.classList.remove("is-hidden");
    }

    btn.addEventListener("click", () => {
      const hiddenItems = Array.from(galleryEl.querySelectorAll(`${SELECTOR_ITEM}.is-hidden`));
      hiddenItems.slice(0, step).forEach((el) => el.classList.remove("is-hidden"));
      updateButtonVisibility();
    });

    updateButtonVisibility();
  }

  function init() {
    document.querySelectorAll(SELECTOR_GALLERY).forEach((galleryEl) => {
      bindLightbox(galleryEl);
      bindViewMore(galleryEl);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
